import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeAuth } from './auth/AuthClient';
import { loadEnvironment, getEnv } from './config';
import { apiClient } from './api/apiClient';
void (async () => {
    await loadEnvironment();
    initializeAuth();
    const apiBaseUrl = getEnv('API_BASE_URL') || process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/dev';
    apiClient.updateBaseURL(apiBaseUrl);
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
})();
